'use client'
import React, { useState, ChangeEvent, FormEvent } from 'react';

// Define an interface for the form data
interface FormData {
  name: string;
  email: string;
  phoneNumber: string;
  userName: string;
  message: string;
}

function App() {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    phoneNumber: '',
    userName: '',
    message: '',
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Here you would typically send the formData to a backend server
    console.log('Form submitted:', formData);
    // Using a custom message box instead of alert() as per instructions
    // For a real application, you'd implement a proper modal or toast notification
    const messageBox = document.createElement('div');
    messageBox.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: white;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 1000;
      text-align: center;
      font-family: 'Inter', sans-serif;
      color: #333;
    `;
    messageBox.innerHTML = `
      <p class="text-lg font-semibold mb-4">Form submitted successfully!</p>
      <p class="text-sm">Check the console for data.</p>
      <button onclick="this.parentNode.remove()" class="mt-4 px-4 py-2 bg-primary text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-primary">
        OK
      </button>
    `;
    document.body.appendChild(messageBox);
    // You can add further logic here, like clearing the form or showing a success message
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4 font-inter">
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-xl w-full max-w-md md:max-w-lg lg:max-w-xl">
        <h1 className="text-2xl sm:text-3xl font-bold text-center mb-6 text-gray-800">Contact Us</h1>

        <p className="text-sm sm:text-base text-gray-600 mb-6 text-center">
          To delete your account please mention the associated email/phone number below and mention 'Delete account' in the message box. Please know that your account will be deleted along with all data linked to the account.
        </p>

        <p className="text-sm sm:text-base text-gray-600 mb-6 text-center">
          For more details please refer to the <a href="/privacy_policy" className="text-primary hover:underline">privacy policy</a>
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="name" className="block text-gray-700 text-base font-medium mb-1">
              Name:
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-gray-700 text-base font-medium mb-1">
              Email:
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
          </div>

          <div>
            <label htmlFor="phoneNumber" className="block text-gray-700 text-base font-medium mb-1">
              Phone Number:
            </label>
            <input
              type="tel"
              id="phoneNumber"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <div>
            <label htmlFor="userName" className="block text-gray-700 text-base font-medium mb-1">
              User Name:
            </label>
            <input
              type="text"
              id="userName"
              name="userName"
              value={formData.userName}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-gray-700 text-base font-medium mb-1">
              Message:
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows={4}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary resize-y"
              required
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-primary text-white py-3 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition duration-300 ease-in-out font-semibold text-lg"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

export default App;
